import * as React from "react";
import { action, observable } from "mobx";
import { observer, inject, Provider } from "mobx-react";
import { EPubStore } from "./EPubStore";
import { EPubChapterView } from "./EPubChapterView";
import { AreaUiInfoImpl } from "../States/AreaUiInfo";


export interface IEPubNavigationViewProps {
    store?: EPubStore;
    areaUiInfo?: AreaUiInfoImpl;
    chapterOpened: () => void;
}

@inject('store')
@inject('areaUiInfo')
@observer
export class EPubNavigationView extends React.Component<IEPubNavigationViewProps, {}> {

    chapterOpened = () => {
        this.props.chapterOpened();
    }

    render() {
        return <div className="area-grid__body-content">
            <Provider navigation={this} areaUiInfo={this.props.areaUiInfo} >
                <div className="treeview">
                    {
                        this.props.store.rootChapters ? <ul>
                            {
                                this.props.store.rootChapters.map(chapter => {
                                    return <EPubChapterView chapter={chapter} key={chapter.linkTarget} chapterOpened={this.chapterOpened} />;
                                })
                            }
                        </ul> : null
                    }
                </div>
            </Provider>
        </div>;
    }
}